<button
  attr.color="{{ buttonColor }}"
  mat-raised-button
  type="button"
  class="pull-right"
  [ngClass]="{
    'doc-read-lookup-button':
      fieldData.type === 'custom-manual-lookup-document',
  }"
  (click)="triggerLookUp($event)"
>
  <span class="button-label">
    <mat-icon>search</mat-icon>{{ buttonLabel }}
  </span>
</button>
